import React, { useState } from "react";
import { Tabs } from "antd";
import { useLocation } from "react-router-dom";
import ClientForm from "./ClientForm";
import EditClientSettings from "../settings/edit";
import ClientTeams from "../teams/index";
import ClientUsers from "../users/index";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";
import { useNavigate } from 'react-router-dom';

const ClientTab = ({ recordId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathParts = location.pathname.split("/").filter(Boolean);
  const lastSegment = pathParts[pathParts.length - 1];
  const [activeTab, setActiveTab] = useState(lastSegment);

  const items = [
    { 
      key: "view", 
      label: "Details", 
      children: (
        <div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
          <SectionHeader title="Client Details">
            <PopupButton id="edit_client" title="Edit Client" label="Edit">
              <ClientForm recordId={recordId} mode="edit" />
            </PopupButton>
          </SectionHeader>
          <ClientForm recordId={recordId} mode="view" />
        </div>
      )
    },
    { 
      key: "client-teams", 
      label: "Teams", 
      children: 
        <ClientTeams clientId={recordId} /> 
    },
    { 
      key: "client-users", 
      label: "Users/Supervisors", 
      children: 
        <ClientUsers clientId={recordId} /> 
    },
    { 
      key: "settings", 
      label: "Settings", 
      children: 
        <EditClientSettings clientId={recordId} /> 
    },
  ];

  const onChange = (key) => {
    console.log(key);
    setActiveTab(key);
    navigate(`/console/clients/${recordId}/${key}`);
  };

  return <Tabs type="card" activeKey={activeTab} onChange={onChange} items={items} />;
};

export default ClientTab;
